import React from 'react';

import { Modal as BootstrapModal } from 'react-bootstrap';

import { ModalContext } from './ModalContext';

import './styles.scss';

interface IModalProps {
    onHide: () => void;
    show: boolean;
    isSubmitting: boolean;
    size?: 'sm' | 'lg' | 'xl';
    variant?: 'light';
    className?: string;
}

export const Modal = (
    {children, isSubmitting, onHide, show, size, variant, className}: React.PropsWithChildren<IModalProps>
) => {
    const context = {
        variant,
        isSubmitting,
        onCancel: onHide
    };

    return (
        <ModalContext.Provider value={context}>
            <BootstrapModal
                show={show}
                onHide={onHide}
                backdrop={isSubmitting ? 'static' : true}
                size={size}
                className={className}
            >
                {children}
            </BootstrapModal>
        </ModalContext.Provider>
    );
};

Modal.defaultProps = {
    isSubmitting: false,
};
